import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://cgkomjgoddulaevzzmup.supabase.co";
const SUPABASE_KEY =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNna29tamdvZGR1bGFldnp6bXVwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzkxNjM0MDEsImV4cCI6MjA1NDczOTQwMX0.4oh3xZ7TQyPfJP0-BzProCYBusz3rplm7bme9bV0WjA";

const SUPABASE_PROJECT_REF = "cgkomjgoddulaevzzmup";

const allCookies = document.cookie;
console.log("All available cookies:", allCookies);

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY, {
    auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
        flowType: "pkce",
        // Use default localStorage-based persistence in all environments (same as localhost)
    },
});

// -------------------------------------------------------------------------
// NEW: Bridge Next.js SSR cookie (sb-<project>-auth-token) into SDK session
// -------------------------------------------------------------------------
(() => {
    try {
        const ssrCookie = document.cookie
            .split("; ")
            .find((row) => row.startsWith(`sb-${SUPABASE_PROJECT_REF}-auth-token=`));

        if (!ssrCookie) {
            console.log("No SSR auth cookie found – user not logged in");
            return;
        }

        console.log("Found SSR auth cookie – bootstrapping Supabase session");

        let rawValue = ssrCookie.split("=")[1];

        // Handle base64 prefix applied by @supabase/auth-helpers
        if (rawValue.startsWith("base64-")) {
            rawValue = atob(rawValue.substring(7));
        } else {
            // browsers may URI-encode the payload; try to decode.
            try {
                rawValue = decodeURIComponent(rawValue);
            } catch (_) {
                /* ignore */
            }
        }

        const { access_token, refresh_token } = JSON.parse(rawValue);

        if (access_token && refresh_token) {
            supabase.auth.setSession({ access_token, refresh_token }).then(({ error }) => {
                if (error) {
                    console.error("Failed to set Supabase session from SSR cookie", error);
                } else {
                    console.log("Supabase session initialised from SSR cookie");
                }
            });
        } else {
            console.warn("SSR cookie parsed but tokens missing");
        }
    } catch (e) {
        console.error("Error bootstrapping Supabase session from SSR cookie", e);
    }
})();
